import { useEffect, useState } from 'react';

// ==============================|| DOCHÁZKA - REFRESH SIGNÁL ||============================== //
// Obecný "něco v docházce se změnilo" pub/sub (2026-08-29, na výslovné přání
// uživatele - "pokud měním něco v modalu a jsem zrovna na stránce, která by
// to měla ukazovat, je asi potřeba udělat refresh daného místa"). Na rozdíl
// od useAttendanceClockState.js (jedna konkrétní hodnota - clockState),
// tenhle hook nic nenese - jen říká "verze se zvýšila, znovu si natáhni
// svoje vlastní data". Volá se po KAŽDÉ úspěšné mutaci docházky
// (píchnutí, propustka, žádost o dovolenou, OČR) odkudkoliv v appce -
// offcanvas accordion, hlavičkové rychlé tlačítko, i plná stránka žádostí -
// a kdokoliv jiný (plná stránka Docházka, dashboard widget, ...) si podle
// něj sám znovu zavolá svoje API.

let version = 0;
const listeners = new Set();

export function notifyAttendanceChanged() {
  version += 1;
  for (const listener of listeners) listener(version);
}

export function useAttendanceRefreshSignal() {
  const [v, setV] = useState(version);
  useEffect(() => {
    const listener = (next) => setV(next);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);
  return v;
}
